export const DASHBOARD_INFLIGHT_STATUS = 'DASH_DATA_INFLIGHT';
export const DASHBOARD_SUCCESS_STATUS = 'DASH_DATA_SUCCESS';
export const DASHBOARD_FAILED_STATUS = 'DASH_DATA_FAILURE';

export const DASHBOARD_STATUSES_LIST = [
  DASHBOARD_INFLIGHT_STATUS,
  DASHBOARD_SUCCESS_STATUS,
  DASHBOARD_FAILED_STATUS,
];
